import { call, put, takeLatest } from "redux-saga/effects";
import {
  i18nLoadRequest,
  i18nLoadSuccess,
  i18nLoadFailure,
  i18nChangeLanguage,
} from "./i18nActions";
import { fetchTranslations } from "../../services/api";
import i18n from "../../i18n/i18n";

function* loadTranslationsWorker(action: ReturnType<typeof i18nLoadRequest>) {
  try {
    const { langId, langCode } = action.payload;

    const bundle: Record<string, string> = yield call(
      fetchTranslations,
      langId
    );

    i18n.addResourceBundle(langCode, "translation", bundle, true, true);

    yield call([i18n, i18n.changeLanguage], langCode);

    yield put(i18nLoadSuccess({ langCode, bundle }));
  } catch (e: any) {
    yield put(i18nLoadFailure(e?.message || "Failed to load translations"));
  }
}

function* changeLanguageWorker(action: ReturnType<typeof i18nChangeLanguage>) {
  try {
    const { langCode } = action.payload;
    yield call([i18n, i18n.changeLanguage], langCode);
  } catch (e) {}
}

export function* i18nRootSaga() {
  yield takeLatest(i18nLoadRequest.type, loadTranslationsWorker);
  yield takeLatest(i18nChangeLanguage.type, changeLanguageWorker);
}
